import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  LeadLostApprovalSettings,
  LeadStage,
} from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import validator from 'validator';
import { DropdownList } from 'react-widgets';

import { convertPascalCaseToWords } from '../../../../core';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: LeadLostApprovalSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: LeadLostApprovalSettings;
  error?: string;
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    watch,
  } = useForm<LeadLostApprovalSettings>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    shouldUnregister: true,
    defaultValues: props.data,
  });

  const renderLeadStage = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Lead Stage</label>
          <Controller
            control={control}
            // rules={{
            //   required: 'Lead Stage is required',
            // }}
            name="leadStage"
            defaultValue={props.data?.leadStage}
            render={({ onChange, value, name }) => (
              <DropdownList
                data={[
                  ...[{ label: 'NONE', value: 'none' }],
                  ...Object.keys(LeadStage).map((key) => {
                    return {
                      label: convertPascalCaseToWords(key),
                      value: key,
                    };
                  }),
                ]}
                id="leadStage"
                placeholder="Select Stage"
                name={name}
                value={value}
                onChange={(val) => onChange(val.value)}
                textField="label"
                valueField="value"
              />
            )}
          />
          <ErrorMessage>{errors.leadStage?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update Lead Lost Approval Settings
        </h4>
        <div className="row gutter-10">
          {renderLeadStage()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
